import { z } from "zod";
export var renovacaoCnhSchema = z.object({
    cpf: z
        .string()
        .min(11, "O CPF deve ter no mínimo 11 dígitos")
        .max(14, "O CPF deve ter no máximo 11 dígitos"),
    ddd: z
        .string()
        .min(2, "O DDD deve ter mínimo 2 dígitos")
        .max(2, "O DDD deve ter no máximo 2 dígitos"),
    celSms: z
        .string()
        .min(9, "O telefone de contato deve ter no mínimo 9 dígitos")
        .max(9, "O telefone de contato deve ter no máximo 9 dígitos"),
    numeroRenach: z
        .string()
        .min(11, "O número do Renach deve ter no mínimo 11 caracteres")
        .max(11, "O número do Renach deve ter no máximo 11 caracteres"),
    envioCarteira: z.string().min(1, "Selecione o tipo de envio da carteira"),
    fotoCondutor: z
        .string()
        .min(1, "Selecione se você deseja reaproveitar a foto atual"),
    atividadeRemunerada: z
        .string()
        .min(1, "Selecione se a atividade é remunerada"),
    juntaMedica: z
        .string()
        .min(1, "Selecione se a CNH é para uma pessoa com deficiência"),
    idCiretran: z.string().min(1, "A ciretran é obrigatório"),
});
export var cnhDefinitivaSchema = z.object({
    cpf: z
        .string()
        .min(11, "O CPF deve ter no mínimo 11 dígitos")
        .max(14, "O CPF deve ter no máximo 11 dígitos"),
    ddd: z
        .string()
        .min(2, "O DDD deve ter mínimo 2 dígitos")
        .max(2, "O DDD deve ter no máximo 2 dígitos"),
    celSms: z
        .string()
        .min(9, "O telefone de contato deve ter no mínimo 9 dígitos")
        .max(9, "O telefone de contato deve ter no máximo 9 dígitos"),
    numeroRenach: z
        .string()
        .min(11, "O número do Renach deve ter no mínimo 11 caracteres")
        .max(11, "O número do Renach deve ter no máximo 11 caracteres"),
    envioCarteira: z.string().min(1, "Selecione o tipo de envio da carteira"),
    idCiretran: z.string().min(1, "A ciretran é obrigatório"),
    fotoCondutor: z
        .string()
        .min(1, "Selecione se você deseja reaproveitar a foto atual"),
});
export var segundoViaSchema = z.object({
    cpf: z
        .string()
        .min(11, "O CPF deve ter no mínimo 11 dígitos")
        .max(14, "O CPF deve ter no máximo 11 dígitos"),
    ddd: z
        .string()
        .min(2, "O DDD deve ter mínimo 2 dígitos")
        .max(2, "O DDD deve ter no máximo 2 dígitos"),
    celSms: z
        .string()
        .min(9, "O telefone de contato deve ter no mínimo 9 dígitos")
        .max(9, "O telefone de contato deve ter no máximo 9 dígitos"),
    numeroRenach: z
        .string()
        .min(11, "O número do Renach deve ter no mínimo 11 caracteres")
        .max(11, "O número do Renach deve ter no máximo 11 caracteres"),
    envioCarteira: z.string().min(1, "Selecione o tipo de envio da carteira"),
    idCiretran: z.string().min(1, "A ciretran é obrigatório"),
    fotoCondutor: z
        .string()
        .min(1, "Selecione se você deseja reaproveitar a foto atual"),
});
export var alterarEnderecoSchema = z.object({
    cpf: z
        .string()
        .min(11, "O CPF deve ter no mínimo 11 dígitos")
        .max(14, "O CPF deve ter no máximo 11 dígitos"),
    numeroRegistro: z.string().min(1, "O número de registro é obrigatório"),
    dataNascimento: z.string().min(1, "A data de nascimento é obrigatória"),
    tipoLogradouro: z
        .string()
        .min(1, "O tipo de logradouro de registro é obrigatório"),
    logradouro: z.string().min(1, "O logradouro é obrigatório"),
    numero: z.string().min(1, "O número é obrigatório"),
    complemento: z.string(),
    bairro: z.string().min(1, "O bairro é obrigatório"),
    cep: z.string().min(1, "O CEP é obrigatório"),
    codLocal: z.number().min(1, "A cidade é obrigatória"),
});
